import { type ReactNode, type FunctionComponent } from "react";
import { Card } from "@lysaab/ui-2";
import "./FloatingAction.scss";

interface Props {
  children: ReactNode;
}

export const FloatingAction: FunctionComponent<Props> = ({ children }) => {
  return (
    <Card className="floating-save-action d-flex mb-0 p-3">{children}</Card>
  );
};
